import type { PopoverListItem } from './popover-list-item.interface.js';

/**
 * Detail payload for the 'item-clicked' event.
 * Dispatched when a non-disabled, non-divider item is clicked.
 */
export interface ItemClickedDetail<T = unknown> {
    item: PopoverListItem<T>;
}

/**
 * Detail payload for the 'item-selected' event.
 * Dispatched by SingleSelectionController when an item is selected.
 */
export interface ItemSelectedDetail<T = unknown> {
    item: PopoverListItem<T>;
}

/**
 * Detail payload for the 'selection-changed' event.
 * Dispatched by MultiSelectionController when the selection changes.
 */
export interface SelectionChangedDetail<T = unknown> {
    selectedItems: PopoverListItem<T>[];
}

/**
 * Detail payload for the 'popover-closed' event.
 * Dispatched when the popover closes, with the reason for closing.
 */
export interface PopoverClosedDetail {
    reason: 'item-selected' | 'dismiss' | 'programmatic';
}

/** Event name constant for item-clicked events. */
export const ITEM_CLICKED_EVENT = 'item-clicked' as const;

/** Event name constant for item-selected events. */
export const ITEM_SELECTED_EVENT = 'item-selected' as const;

/** Event name constant for selection-changed events. */
export const SELECTION_CHANGED_EVENT = 'selection-changed' as const;

/** Event name constant for popover-closed events. */
export const POPOVER_CLOSED_EVENT = 'popover-closed' as const;
